'use client';

import Button from '@carvana/ds-button';
import useTestDriveCenter from '~/hooks/new-cars/useTestDriveCenter';

export default function TdcHeader() {
  const { endSession, session } = useTestDriveCenter();

  return (
    <div
      className="flex items-center gap-md border-b border-border-default bg-background-default px-2xl py-md"
      data-testid="tdc-header"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-interactive-default"
      >
        <circle cx="12" cy="12" r="10" />
        <polygon
          points="10 8 16 12 10 16 10 8"
          fill="currentColor"
          stroke="none"
        />
      </svg>
      <span className="t-label-sm font-semibold text-text-strong">
        Test Drive Center
      </span>
      {session && (
        <Button
          className="ml-auto opacity-60"
          data-analytics-id="New Cars TDC"
          data-testid="tdc-end-session"
          onClick={endSession}
          size="sm"
          variant="secondary"
        >
          End Session
        </Button>
      )}
    </div>
  );
}
